/* eslint-env browser */
import axios from 'axios'
import * as React from 'react'

import withTranslator from '../../../client/clientjs/components/TranslatorProvider'

const PropTypes = require('prop-types')

const Table = require('../../../client/clientjs/components/Table')

class Ranking extends React.Component {
  constructor(props) {
    super(props)

    const { rounds = [], ranking = [], teamsById = {}, contestSeoName, lastRoundCountsAsTotal, translate } = props

    this.state = {
      ranking,
      columns: [
        {
          name: 'rank',
          display: translate('ranking.rank'),
          getCellValue: row => row.rank,
          isSortable: true,
          isBold: true,
          isTextCentered: true,
        },
        {
          name: 'teamName',
          display: 'Team',
          getCellValue: row => {
            const team = teamsById[row.teamId]
            let nationality
            if (team) {
              ;({ nationality } = team.members.find(m => m.isCaptain) || {})
            }

            return (
              <span>
                {row.teamName} &nbsp;
                {nationality && (
                  <img
                    style={{ marginTop: 0, height: 10 }}
                    title={nationality}
                    alt={nationality}
                    src={`https://flagpedia.net/data/flags/small/${nationality.toLowerCase()}.png`}
                  />
                )}
                <a href={`/contests-force-web/${contestSeoName}/teams/${row.teamId}`} target="_blank" rel="noreferrer">
                  <span className="icon">
                    <i className="fas fa-external-link" style={{ fontSize: '0.8em' }} />
                  </span>
                </a>
              </span>
            )
          },
          getCellRawValue: row => row.teamName,
          isSortable: true,
          getCellSubRowValue: (row, subRow) => <small className="has-text-right">{subRow.display}</small>,
          isSubRowTextCentered: true,
        },
      ]
        .concat(
          lastRoundCountsAsTotal
            ? []
            : [
                {
                  name: 'totalRoundsPoints',
                  display: 'TOTAL POINTS',
                  centered: true,
                  bold: true,
                  getCellValue: row => row.totalRoundsPoints,
                  disableRotate: rounds.length <= 4,
                  isSortable: true,
                  isBold: true,
                  isTextCentered: true,
                },
              ]
        )
        .concat(
          rounds.map(round => ({
            name: `scoresByRound.${round.id}`,
            display: round.name,
            getCellValue: row => {
              const { points, score } = row.scoresByRound[round.id] || {}
              if (round.validCircleClass === 'not-started') {
                return <span />
              }

              return (
                <span>
                  <b>{points}</b>
                  {` (${score})`}
                </span>
              )
            },
            getCellRawValue: row => {
              const { points = 0, score = 0 } = row.scoresByRound[round.id]
              // we pad because the filter will use a string filter ! so with padding zeros we compare the right thing
              return `${`${(points || 0) * 1000}`.padStart(15, '0')}-${`${(score || 0) * 1000}`.padStart(15, '0')}`
            },
            isSortable: true,
            isTextCentered: true,
            getCellSubRowValue: (row, subRow) =>
              (subRow.values[round.id] || []).length > 0 && (
                <span dangerouslySetInnerHTML={{ __html: (subRow.values[round.id] || []).join('<br/>') }} />
              ),
            isSubRowTextCentered: true,
            validCircleClass: round.validCircleClass,
          }))
        ),
    }
    this.onRowClick = this.onRowClick.bind(this)
  }

  onRowClick(row) {
    const { contestId, teamsById } = this.props
    const { ranking } = this.state

    const rowRankingIndex = ranking.findIndex(elt => elt.teamId === row.teamId)
    if (rowRankingIndex === -1) {
      return
    }
    const rowRanking = ranking[rowRankingIndex]
    ranking[rowRankingIndex] = {
      ...rowRanking,
      isDisplayed: !rowRanking.isDisplayed,
      subRowsLoading: true,
    }
    this.setState({
      ranking,
    })
    if (!rowRanking || rowRanking.subRowsLoading) {
      return
    }
    axios
      .get(`/api/contests/${contestId}/individualParticipations`, {
        params: { userIds: ((teamsById[row.teamId] || {}).members || []).map(elt => elt.id) },
      })
      .then(response => {
        const { data = {} } = response
        const { bonuses = [], participations = [], fishesQuotaBonuses = [], differentSpeciesQuotasBonuses = [] } = data
        let subRows = bonuses.reduce((aggreg, bonus) => {
          const message = bonus.message || ''
          aggreg[message] = aggreg[message] || {
            display: message,
            values: {},
          }
          aggreg[message].values[bonus.roundId] = aggreg[message].values[bonus.roundId] || []
          aggreg[message].values[bonus.roundId].push(bonus.score)
          return aggreg
        }, {})
        subRows = fishesQuotaBonuses.reduce((aggreg, fishQuotaBonus) => {
          if (fishQuotaBonus.fishQuotaBonus > 0 === false) {
            return aggreg
          }
          const message = `${fishQuotaBonus.fishName || ''} / Bonus Quota`
          aggreg[message] = aggreg[message] || {
            display: message,
            values: {},
          }
          aggreg[message].values[fishQuotaBonus.roundId] = aggreg[message].values[fishQuotaBonus.roundId] || []
          aggreg[message].values[fishQuotaBonus.roundId].push(fishQuotaBonus.fishQuotaBonus)
          return aggreg
        }, subRows)
        subRows = differentSpeciesQuotasBonuses.reduce((aggreg, differentSpeciesQuotaBonus) => {
          if (differentSpeciesQuotaBonus.bonus > 0 === false) {
            return aggreg
          }
          const message = `Bonus ${differentSpeciesQuotaBonus.differentSpeciesCountForBonus} espèces`
          aggreg[message] = aggreg[message] || {
            display: message,
            values: {},
          }
          aggreg[message].values[differentSpeciesQuotaBonus.roundId] =
            aggreg[message].values[differentSpeciesQuotaBonus.roundId] || []
          aggreg[message].values[differentSpeciesQuotaBonus.roundId].push(differentSpeciesQuotaBonus.bonus)
          return aggreg
        }, subRows)
        subRows = participations.reduce((aggreg, participation) => {
          let message = ''
          if (participation.fishCatch) {
            const { fish, speciesCustomName } = participation.fishCatch
            if (fish && fish.names) {
              const { names } = fish
              if (names.length > 0) {
                message = names[0].value
              }
            }
            if ((message || '').length === 0) {
              message = speciesCustomName
            }
          }
          if ((message || '').length === 0) {
            message = ''
          }
          aggreg[message] = aggreg[message] || {
            display: message,
            values: {},
          }
          aggreg[message].values[participation.roundId] = aggreg[message].values[participation.roundId] || []
          aggreg[message].values[participation.roundId].push(participation.score)
          return aggreg
        }, subRows)
        subRows = Object.values(subRows).sort((a, b) => {
          const sumA = (Object.values(a.values) || []).flat().reduce((res, elt) => res + elt, 0)
          const sumB = (Object.values(b.values) || []).flat().reduce((res, elt) => res + elt, 0)
          return sumB - sumA
        })

        this.setState(prevState => {
          const newRanking = prevState.ranking
          newRanking[rowRankingIndex] = {
            ...newRanking[rowRankingIndex],
            subRows,
            subRowsLoading: false,
          }
          return {
            ranking: newRanking,
          }
        })
      })
  }

  render() {
    const { lastRoundCountsAsTotal, scoreLessIsMore, rounds = [] } = this.props
    const { columns, ranking } = this.state

    let defaultSortBy = null

    if (lastRoundCountsAsTotal) {
      let lastRunningRound = null
      rounds.forEach(round => {
        if (round.validCircleClass !== 'not-started') {
          lastRunningRound = round
        }
      })
      if (lastRunningRound) {
        defaultSortBy = `scoresByRound.${lastRunningRound.id}`
      }
    } else {
      defaultSortBy = 'totalRoundsPoints'
    }

    return (
      <Table
        columns={columns}
        rows={ranking}
        defaultSortBy={defaultSortBy}
        defaultSortASC={scoreLessIsMore}
        getRowKey={row => row.teamId}
        onRowClick={this.onRowClick}
        getSubRows={row => (row.isDisplayed ? row.subRows || [] : [])}
        getSubRowKey={(row, subRow) => `${row.userId}-subrow-${subRow.display}`}
        tableClass="is-size-7 is-size-8-mobile is-self-centered"
      />
    )
  }
}

Ranking.propTypes = {
  ranking: PropTypes.array,
  rounds: PropTypes.array,
  teamsById: PropTypes.object,
  contestId: PropTypes.string.isRequired,
  contestSeoName: PropTypes.string.isRequired,
  scoreLessIsMore: PropTypes.bool,
  lastRoundCountsAsTotal: PropTypes.bool,
}

Ranking.defaultProps = {
  teamsById: {},
  ranking: [],
  rounds: [],
  scoreLessIsMore: false,
  lastRoundCountsAsTotal: false,
}

module.exports = withTranslator(Ranking)
